import Link from 'next/link'

// Styles
import * as S from './styles'

// Components
import { Menu } from 'components/Navigation/Menu/'

// Images
import { LogoSwile } from 'components/Image/Svg/LogoSwile'

import packageData from '../../../package.json'

export const Aside = () => {
  return (
    <S.Aside>
      <S.Header>
        <Link href="/">
          <LogoSwile />
        </Link>
      </S.Header>

      <Menu />

      <S.AppVersion>
        v{packageData.version} ({process.env.NEXT_PUBLIC_DD_VERSION})
      </S.AppVersion>
    </S.Aside>
  )
}
